import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadingPromise?: Promise<void>;

  load(libraries: string[] = ['places']): Promise<void> {
    if (this.isLoaded()) return Promise.resolve();
    if (this.loadingPromise) return this.loadingPromise;

    const apiKey = (environment as any)?.googleMaps?.apiKey || (environment as any)?.firebase?.apiKey || '';
    if (!apiKey) {
      console.warn('[GoogleMapsLoader] No se encontró firebase.apiKey para cargar Google Maps');
      return Promise.resolve(); // continuar en modo manual
    }

    this.loadingPromise = new Promise<void>((resolve, reject) => {
      const scriptId = 'google-maps-script';
      if (document.getElementById(scriptId)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.id = scriptId;
      const libs = libraries.join(',');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libs}&v=beta&loading=async&language=es`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = (e) => {
        console.error('[GoogleMapsLoader] Error cargando el script de Google Maps', e);
        reject(e);
      };
      document.head.appendChild(script);
    });

    return this.loadingPromise;
  }

  isLoaded(): boolean {
    return typeof (window as any).google !== 'undefined' && !!(window as any).google.maps;
  }

  // Busca una dirección de texto y devuelve el primer resultado de Places/Geocoder
  async searchAddress(query: string): Promise<any> {
    if (!query || !query.trim()) {
      throw new Error('searchAddress: query vacío');
    }

    await this.load(['places']);
    const g = (window as any).google;
    if (!g || !g.maps) {
      throw new Error('searchAddress: Google Maps no está cargado');
    }

    return new Promise<any>((resolve, reject) => {
      try {
        const service = new g.maps.places.PlacesService(document.createElement('div'));
        const request = {
          query,
          fields: ['formatted_address', 'address_components', 'geometry', 'name']
        };

        service.findPlaceFromQuery(request, (results: any[], status: any) => {
          if (status !== g.maps.places.PlacesServiceStatus.OK || !results || results.length === 0) {
            return reject(new Error('searchAddress: sin resultados válidos'));
          }
          // Normalizar el objeto para que tenga address_components/formatted_address como en el modal
          const place = results[0];
          resolve(place);
        });
      } catch (e) {
        reject(e);
      }
    });
  }
}
